import Logo from './Logo';
import AnimatedGradientLayer from './AnimatedGradientLayer';
import { motion, AnimatePresence } from 'motion/react';
import { useState, useEffect } from 'react';

const Landing = ({ elementsVisible = true }) => {
  const phrases = [
    "How do your data center\nneeds change as AI scales?",
    "How is your network evolving to\nmeet the demands of AI and IoT?",
    "How are you transforming your\nworkplace to harness AI?",
    "How quickly can you detect and\nstop critical incidents to prevent downtime?",
    "How do you counter escalating\nthreats in the AI era?",
    "How is AI empowering\nyour IT team?"
  ];

  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPhraseIndex((prevIndex) => (prevIndex + 1) % phrases.length);
    }, 20000); // Cambia cada 20 segundos

    return () => clearInterval(interval);
  }, [phrases.length]);

  return (

        <div
          className="fixed inset-0 z-[9999] bg-[#07182D] flex flex-col items-center"
        >
          {/* Logo */}
          <motion.div
            animate={{
                opacity: elementsVisible ? 1 : 0,
                filter: elementsVisible ? "blur(0px)" : "blur(10px)"
            }}
            transition={{ duration: 1, ease: "easeOut" }}
          >
            <Logo className="w-373u h-auto aspect-16-9:mt-251u not-aspect-16-9:mt-350u aspect-16-9:mb-296u not-aspect-16-9:mb-396u" />
          </motion.div>
          

          {/* Texto */}
          <div className="text-center text-210u leading-252u font-light relative">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentPhraseIndex}
                initial={{ opacity: 0, filter: "blur(10px)" }}
                animate={{ opacity: elementsVisible ? 1 : 0, filter: elementsVisible ? "blur(0px)" : "blur(10px)" }}
                exit={{ opacity: 0, filter: "blur(10px)" }}
                transition={{ duration: 1, ease: "easeOut" }}
                className="whitespace-pre-line"
              >
                {phrases[currentPhraseIndex]}
              </motion.div>
            </AnimatePresence>
          </div>

          <motion.div 
            className="text-center text-52u leading-65u mt-auto mb-208u relative z-10"
            animate={{
                opacity: elementsVisible ? 1 : 0,
                filter: elementsVisible ? "blur(0px)" : "blur(10px)"
            }}
            transition={{ duration: 1, ease: "easeOut", delay: 0.3 }}
          >
            Connect with a Cisco expert to<br />begin the conversation
          </motion.div>

          <AnimatedGradientLayer />
        </div>
  );
};

export default Landing;